import { FilterContentFieldDataTypes } from '../../filter/constants';
import { Filter } from '../../filter/interface';
import { JOB_STATUS_DATA_MAP } from './job-stage';

const JOB_MODE_OPTIONS = [
  { label: 'Incremental', value: 'INCREMENTAL' },
  { label: 'Historical', value: 'HISTORICAL' },
  { label: 'Truncate and Load', value: 'TRUNCATE_AND_LOAD' }
];

const JOB_STATUS_OPTIONS = Object.values(JOB_STATUS_DATA_MAP).map(status => ({
  ...status,
  label: status.displayName
}));

export const JOBS_FILTERS: Filter[] = [
  {
    title: 'Status',
    filterKey: 'status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      displayAccessor: 'displayName',
      options: JOB_STATUS_OPTIONS,
      selectMode: true
    }
  },
  {
    title: 'Job type',
    filterKey: 'job_type',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      options: JOB_MODE_OPTIONS,
      selectMode: true
    }
  },
  {
    title: 'Started at',
    filterKey: 'created_at',
    filterType: FilterContentFieldDataTypes.DATE,
    filterContentProps: {
      filterText: 'Date in range',
      showPredefinedDateChips: true,
      startDateProps: {
        disableOpenPicker: true
      },
      endDateProps: {
        disableOpenPicker: true
      }
    }
  }
];
